import { render, staticRenderFns } from "./AdmSlot.vue?vue&type=template&id=7037bac4&scoped=true"
import script from "./AdmSlot.vue?vue&type=script&lang=js"
export * from "./AdmSlot.vue?vue&type=script&lang=js"
import style0 from "./AdmSlot.vue?vue&type=style&index=0&id=7037bac4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7037bac4",
  null
  
)

export default component.exports